// HTML
export default `<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.999998 1L4.46356 5.15627C5.26315 6.11578 6.73685 6.11578 7.53644 5.15627L11 1" stroke="#C4C4C4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>
`